import { Icon, LatLngLiteral } from "leaflet";

import { InputValue } from "../components/forms/Input";

import MarkerSvg from "./images/marker.svg";

const POINT_MATCH = /POINT \((?<lng>[0-9.]+) (?<lat>[0-9.]+)\)/;

export const MarkerIcon = new Icon({
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  iconAnchor: [20, 40],
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  iconSize: [40, 40],
  iconUrl: MarkerSvg,
});

export const parseLatLng = (
  location?: InputValue,
):
  | undefined
  | {
      lat: number;
      lng: number;
    } => {
  if (Array.isArray(location)) {
    return parseLatLng(location[0]);
  }
  if (typeof location !== "string") {
    return undefined;
  }

  const { lat, lng } = location.match(POINT_MATCH)?.groups ?? {};

  if (lat && lng) {
    return {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };
  }

  return undefined;
};

export const serializePoint = (point: LatLngLiteral) =>
  `POINT (${point.lng} ${point.lat})`;
